// extracted by mini-css-extract-plugin
export default {"username-cell":"TabStyles_username-cell__jiIul","table-container":"TabStyles_table-container__9FKCx"};